import React, { PropsWithChildren } from 'react';
import { useShowHideWidgetToolbar } from 'widgets/WidgetToolbarShowHidePanel/hooks';
import ShowHidePanel from 'utils/components/ShowHidePanel/ShowHidePanel';
import { useWidgetContext } from 'widgets/WidgetContext';
import { WidgetConfigWithHideableToolbar } from 'widgets/WidgetToolbarShowHidePanel/WidgetConfigWithHideableToolbar';

type WidgetToolbarShowHidePanelProps<T = WidgetConfigWithHideableToolbar> =
    PropsWithChildren<{
        /*
         * If true the children will be displayed regardless of the config
         */
        mustShow: boolean;
        allowHide?: boolean;
        propertyName?: keyof T;
    }>;

/*
 * Provides a show/hide panel based on the widget configs "hideToolbar" setting
 * Renders the provided children (probably a toolbar) if
 * - hideToolbar in the settings is false
 * - there are warning message for the widget
 * - the provided "mustShow" is true (eg we have no selection and the children include the selection warning)
 */
export default function WidgetToolbarShowHidePanel<
    T = WidgetConfigWithHideableToolbar,
>(props: WidgetToolbarShowHidePanelProps<T>) {
    const { children, mustShow, propertyName } = props;

    const { isHovering: showToggleButton } = useWidgetContext();
    const { showToolbar, allowCollapse, toggleCollapse } =
        useShowHideWidgetToolbar<T>(mustShow, propertyName);

    return (
        <>
            {allowCollapse && (
                <ShowHidePanel
                    shown={!showToolbar}
                    showToggleButton={showToggleButton}
                    onToggle={toggleCollapse}
                    showTooltip={'Show Toolbar'}
                    hideTooltip={'Hide Toolbar'}
                />
            )}
            {showToolbar && <>{children}</>}
        </>
    );
}
